import { Button, Col, Flex, Row } from "antd";
import DocumentIcon from "../../../../../assets/icons/DocumentIcon";
import DownloadIcon from "../../../../../assets/icons/DownloadIcon";
import ViewIcon from "../../../../../assets/icons/ViewIcon";
import ImageModal from "../../../../../components/ui/ImageModal";
import { Document } from "../../../../../features/Vendor/vendor.type";

const DocumentDetails = ({ data }: { data?: Document[] }) => {
  return (
    <Row gutter={[16, 16]} className="mt-5">
      {/* <ImageModal
        open={true}
        onCancel={() => console.log(false)}
        data={
          "https://sheba-dev-digigo-bucket.s3.ap-southeast-1.amazonaws.com/upload/1758650699779-blank.pdf"
        }
      /> */}
      {data?.map((doc, index) => {
        const fileUrl = doc?.document_url;
        const fileName = fileUrl?.split("/").pop() || "document";

        // Extract file extension and convert to uppercase
        const fileType = fileName.split(".").pop()?.toUpperCase() || "FILE";

        return (
          <Col key={index} span={8}>
            <div className="border border-theme-indigo-25 rounded-xl p-4">
              <Flex justify="space-between" className="mb-4">
                <DocumentIcon />
                <Flex gap={8}>
                  {/* View Button */}
                  <Button
                    className="border-none size-7 p-0 shadow-none"
                    // onClick={() => window.open(fileUrl, "_blank")}
                  >
                    <ViewIcon size={24} />
                  </Button>

                  {/* Download Button */}
                  <Button
                    className="border-none size-7 p-0 shadow-none"
                    onClick={() => {
                      const link = document.createElement("a");
                      link.href = fileUrl;
                      link.target = "_blank";
                      link.rel = "noopener noreferrer";
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);
                    }}
                  >
                    <DownloadIcon />
                  </Button>
                </Flex>
              </Flex>

              <h6 className="text-sm font-medium text-theme-gray-900">
                {doc.document_name}
              </h6>
              <span className="text-sm text-theme-gray-50">
                {fileType} Document
              </span>
            </div>
          </Col>
        );
      })}
    </Row>
  );
};

export default DocumentDetails;
